"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const material_1 = require("@mui/material");
const colors_1 = require("../../../styles/colors");
const Typo_1 = require("../Typo/Typo");
const StyledFormControl = (0, styled_1.default)(material_1.FormControl) `
  min-width: 100px;
`;
const StyledInputLabel = (0, styled_1.default)(material_1.InputLabel) `
  color: ${colors_1.$grey40};
  font-size: ${({ size }) => (size === 'small' ? '10px' : '12px')};
  font-weight: 300;
  margin-bottom: ${({ className }) => (className === 'standard' ? '' : '5px')};
  position: ${({ className }) => (className === 'standard' ? '' : 'relative')};
  transform: none;
`;
const StyledSelect = (0, styled_1.default)(material_1.Select) `
  border-radius: 4px;
`;
const StyledFormHelperText = (0, styled_1.default)(material_1.FormHelperText) `
  color: ${colors_1.$grey40};
  font-size: ${({ className }) => (className === 'small' ? '10px' : '12px')};
  font-weight: 300;
`;
const SelectInput = (_a) => {
    var _b;
    var { helperText, isError, variant } = _a, rest = __rest(_a, ["helperText", "isError", "variant"]);
    return ((0, jsx_runtime_1.jsxs)(StyledFormControl, Object.assign({ "data-testid": "select-input", fullWidth: true, variant: variant, error: isError }, { children: [(0, jsx_runtime_1.jsx)(StyledInputLabel, Object.assign({ "data-testid": "input-label", id: rest.labelId, className: variant, size: rest.size === 'small' ? 'small' : 'normal' }, { children: rest.label })), (0, jsx_runtime_1.jsx)(StyledSelect, Object.assign({}, rest, { defaultValue: rest.defaultValue ? rest.defaultValue : '', notched: variant === 'outlined' ? false : null, error: isError, labelId: rest.labelId, id: rest.labelId, label: rest.label, size: rest.size }, { children: (_b = rest.options) === null || _b === void 0 ? void 0 : _b.map((option, index) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, Object.assign({ "data-testid": "menu-item", value: index }, { children: (0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ variant: rest.size === 'small' ? 'body2' : 'body1' }, { children: option })) }), index))) })), (helperText === null || helperText === void 0 ? void 0 : helperText.length) && variant === 'standard' ? ((0, jsx_runtime_1.jsx)(StyledFormHelperText, Object.assign({ "data-testid": "helper-text", className: rest.size === 'small' ? 'small' : 'medium' }, { children: helperText }))) : null] })));
};
exports.SelectInput = SelectInput;
